export interface ProviderFlexSearchRequest {
  providerTaxId: string;
  serviceLocationHashCode?: string;
  serviceLocationSequence?: string;
  activeFlag: boolean;
  asofdate: string;
}

export interface ProviderFlexSearchResponse {
  providerFlexSearchItems: ProviderFlexSearchItem[];
}

export interface ProviderFlexSearchItem {
  networkFlexData: NetworkFlexDatum[];
}

export interface NetworkFlexDatum {
  networkId: string;
  effectiveDoctorType?: string;
}

export enum ProviderFlexLookupResultStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export interface ProviderFlexLookupResult {
  status: ProviderFlexLookupResultStatus;
  networkId?: string;
  effectiveDoctorType?: string;
}
